import { gql } from "@apollo/client";export default gql`mutation deletePlan($id: Int!) {
  deletePlan: delete_subscription_plan_by_pk(id: $id) {
    id
  }
}
`;
